import React, { useState } from "react";
import "./CourseCards.css";
import InquiryForm from "../../AllCoursesPage/InquiryForm"; // ✅ Import popup
import img10 from "./img/8800992_855.jpg";
import img1 from "./img/digital-marketing-with-icons-business-people.jpg";
import img2 from "./img/wde.jpg";
import img4 from "./img/16683353_5757453.jpg";
import img5 from "./img/Machine-1024x576.png";
import img6 from "./img/cyber-security-background-meuqfzxcg4gdd26s.jpg";
import img7 from "./img/CHALLENGES-OF-CLOUD-COMPUTING-1080x675.webp";
import img8 from "./img/What-is-data-science-2.jpg";
import img9 from "./img/blockchain.jpg";
import img3 from "./img/95296.jpg";
import img11 from "./img/1685965315663.jpeg";
import img12 from "./img/How_to_Hire_Top_Mobile_App_Development_Services_Company_d9bf87648b.webp";

const courses = [
  {
    title: "Digital Marketing",
    rating: 5,
    description:
      "Learn SEO, Social Media, PPC Ads & complete digital growth strategies.",
    image: img1,
  },
  {
    title: "Web Development",
    rating: 5,
    description:
      "Master HTML, CSS, JavaScript & PHP to build dynamic websites.",
    image: img2,
  },
  {
    title: "Data Analytics",
    rating: 5,
    description:
      "Analyze data with Excel, Power BI, and SQL for real business insights.",
    image: img3,
  },
  {
    title: "UI/UX Design",
    rating: 4.5,
    description:
      "Design beautiful and user-friendly websites & apps with Figma and Adobe XD.",
    image: img4,
  },
  {
    title: "Machine Learning",
    rating: 4.5,
    description:
      "Build predictive models with Python, scikit-learn, and TensorFlow.",
    image: img5,
  },
  {
    title: "Cyber Security",
    rating: 5,
    description:
      "Learn ethical hacking, network defense, and cyber risk management.",
    image: img6,
  },
  {
    title: "Cloud Computing",
    rating: 4,
    description:
      "Master AWS, Azure, and Google Cloud to build scalable solutions.",
    image: img7,
  },
  {
    title: "Data Science",
    rating: 4.5,
    description:
      "Learn Python, ML & AI to solve real-world problems with data-driven models.",
    image: img8,
  },
  {
    title: "Blockchain",
    rating: 4,
    description:
      "Understand blockchain technology, crypto, and decentralized apps.",
    image: img9,
  },
  {
    title: "AI Engineering",
    rating: 4.5,
    description:
      "Build intelligent AI solutions with NLP, Deep Learning & TensorFlow.",
    image: img10,
  },
  {
    title: "Big Data",
    rating: 4,
    description: "Process & analyze massive datasets using Hadoop & Spark.",
    image: img11,
  },
  {
    title: "Mobile Development",
    rating: 4.5,
    description: "Build Android & iOS apps with React Native and Flutter.",
    image: img12,
  },
];

const itemsPerPage = 8; // Show 8 per page

const CourseCards = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [showForm, setShowForm] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);

  const totalPages = Math.ceil(courses.length / itemsPerPage);

  // Get 8 courses for current page
  const startIndex = (currentPage - 1) * itemsPerPage;
  const selectedCourses = courses.slice(startIndex, startIndex + itemsPerPage);

  const handleEnquiryClick = (course) => {
    setSelectedCourse(course.title);
    setShowForm(true);
  };

  return (
    <div>
      {/* Course Cards */}
      <div className="card-container">
        {selectedCourses.map((course, index) => (
          <div className="course-card" key={index}>
            <img
              src={course.image}
              alt={course.title}
              className="course-image"
            />
            <div className="course-content">
              <h3>{course.title}</h3>
              <p className="rating">
                {"⭐".repeat(Math.floor(course.rating))}
                {course.rating % 1 !== 0 ? "⭐" : ""} ({course.rating})
              </p>
              <p className="description">{course.description}</p>
              <div className="button-group">
                <button className="btn read-more">Read More</button>
                <button
                  className="btn enquiry"
                  onClick={() => handleEnquiryClick(course)}
                >
                  Enquiry
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <div className="pagination">
        <span>
          Page {currentPage} of {totalPages}
        </span>

        <div className="page-numbers">
          {currentPage > 1 && (
            <button
              className="page-btn prev-btn"
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              PREVIOUS
            </button>
          )}

          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              className={`page-btn ${page === currentPage ? "active" : ""}`}
              onClick={() => setCurrentPage(page)}
            >
              {page}
            </button>
          ))}

          {currentPage < totalPages && (
            <button
              className="page-btn next-btn"
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              NEXT
            </button>
          )}
        </div>
      </div>

      {/* ✅ Enquiry Popup */}
      {showForm && (
        <InquiryForm
          courses={[selectedCourse]} // pass single course as array
          onClose={() => setShowForm(false)}
        />
      )}
    </div>
  );
};

export default CourseCards;
